import ConfigsUtils from '../../base/aem-configs/config-utils.js';
import { simpleLightbox } from '../../base/dom-utils.js';
import Analytics from '../../base/wyn-analytics-module.js';
import { $_PAGE_ } from '../../base/vars.js';
import { UserHandler } from '../../base/session-handler.js';

class PointsDotCom {

  constructor() { 
    this.getPointsComConfig = ConfigsUtils.getPointsComConfig();
    this.getPointsComBrandConfig = ConfigsUtils.getPointsComBrandConfig();
    this.storefront;
    this.purchase = false;
  }

  pointsDotComInit() {
    if (this.pointsDotComDefined() && this.pointsDotComBrandDefined()) {
      if (this.getPointsComBrandConfig.attributes.hasOwnProperty('memberMinPointsDisplyModal') && this.getPointsComBrandConfig.attributes.hasOwnProperty('memberMaxPointsPurchaseLimit')) {
        let scriptTag = document.createElement("script");
        //assigning attributes to script tag
        scriptTag.setAttribute("type", "text/javascript");
        scriptTag.setAttribute("src", this.getPointsComConfig.environmentPointsComScriptUrl);
        scriptTag.setAttribute("integrity", this.getPointsComConfig.integritySha512HashCode);
        scriptTag.setAttribute("data-drop-in-version", "v1");
        scriptTag.setAttribute("data-partner", this.getPointsComConfig.storeFrontPartnersName);
        scriptTag.setAttribute("crossorigin", "anonymous");
        //appending on head tag
        document.head.appendChild(scriptTag);
      }
    }
  }

  pointsTopupModalDisplay(oktaAccessToken, isWRPoints, ratesCurrencyCode, ratesLocaleCode, hotelName, checkInDate, checkOutDate, memberPoints, freeStayPoints, triggerReserveCallback) {
    let requiredPoints = freeStayPoints - memberPoints;
    if (parseInt(memberPoints) < parseInt(freeStayPoints)) {
      if (this.pointsDotComDefined() && this.pointsDotComBrandDefined()) {
        if (this.getPointsComBrandConfig.attributes.hasOwnProperty('memberMinPointsDisplyModal') && this.getPointsComBrandConfig.attributes.hasOwnProperty('memberMaxPointsPurchaseLimit')) {
          let minPoints = parseInt(this.getPointsComBrandConfig.attributes.memberMinPointsDisplyModal);
          let maxDeltaPoints = parseInt(this.getPointsComBrandConfig.attributes.memberMaxPointsPurchaseLimit);

          const bookingDateFormatted = new Date().toISOString().split('.')[0] + '.000';
          if (isWRPoints && parseInt(memberPoints) >= parseInt(minPoints) && parseInt(requiredPoints) <= parseInt(maxDeltaPoints)) {

            let hotelBookingDetails = {
              bookingDate: bookingDateFormatted,
              checkInDate: checkInDate,
              checkOutDate: checkOutDate,
              propertyName: hotelName,
            };

            const brandConfigBookCurveVal = this.getPointsComBrandConfig.attributes.bookingCurveValue;
            if (brandConfigBookCurveVal != null && brandConfigBookCurveVal !== '') {
              hotelBookingDetails.bookingCurveValue = brandConfigBookCurveVal;
            }

            this.storefront = new window.Storefront({
              storefrontName: this.getPointsComConfig.storeFrontName,
              language: ratesLocaleCode,
              currency: ratesCurrencyCode,
              product: this.getPointsComConfig.productPointsTopup,
              auth: {
                flow: "oauth",
                accessToken: oktaAccessToken,
              },
              productConfig: {
                hotelBookingDetails: hotelBookingDetails
              },
              mode: this.getPointsComConfig.modePointsTopup,
              queryParameters: {
                transactionQuantity: String(requiredPoints),
                redemptionQuantity: String(freeStayPoints),
              },
              onError: (error) => this.pointsDotComEvent(error, triggerReserveCallback),
              onEvent: (event) => this.pointsDotComEvent(event, triggerReserveCallback),
              onWarn: (warning) => this.pointsDotComEvent(warning, triggerReserveCallback),
            });

            //launching modal
            if (this.storefront) {
              this.storefront.mount(document.body);
            }
          } else if ((parseInt(memberPoints) < parseInt(minPoints)) || (parseInt(requiredPoints) > parseInt(maxDeltaPoints))) {
            $_PAGE_.removeClass('loading');
            if (typeof window.notEnoughPointsMessage !== 'undefined') {
              simpleLightbox(window.notEnoughPointsMessage || 'Additional points are required to reserve this room.');
            } else {
              simpleLightbox('Additional points are required to reserve this room.');
            }
          }
        } else {
          $_PAGE_.removeClass('loading');
          console.error("error");
        }
      }
    }
  }

  pointsDotComEvent(event, triggerReserveCallback) {
    console.log(event);
    if (event) {
      if (event == 'initial') {
        $_PAGE_.removeClass('loading');
        console.log('initial', event);
      } else if (event == 'incrementSelected') {
        console.log('incrementSelected', event);
      } else if (event == 'termsAndConditionsAccepted') {
        console.log(event);
      } else if (event == 'returnToBooking') {
        console.log('returnToBooking', event);
        Analytics.satelliteTracker('pointsPopupReturnToBookingClick');
        if (this.purchase) {
          window.location.reload();
          // UserHandler.ProfileUpdateOnPOints();
        }
      } else if (event == 'purchase') {
        this.purchase = true;
        console.log('purchase', event);
        UserHandler.ProfileUpdateOnPOints();
        $('.topup-banner-container').addClass('hidden');
        $('.buy-points').removeClass('buy-points');
        Analytics.satelliteTracker('pointsPopupBuyNowClick');
      } else if (event == 'continueBooking') {
        console.log('continueBooking', event);
        Analytics.satelliteTracker('buyPointsContinueBookingLinkClick');
        if (typeof triggerReserveCallback === 'function') {
          triggerReserveCallback();
        } else {
          if (this.purchase) {
            window.location.reload();
          }
        }
      }else if (event == 'modalClosed') {
        if (this.purchase) {
          window.location.reload();
          console.log('modalClosed', event);
        }else{
          console.log('modalClosed without purchase', event);
        }
      }else if (event == 'error') {
        //modalClosed
        $_PAGE_.removeClass('loading');
        console.log('error', event);
      } else if (event == 'error-initialization') {
        $_PAGE_.removeClass('loading');
        console.log('error-initialization', event);
      } else if (event == 'error-purchase') {
        $_PAGE_.removeClass('loading');
        console.log('error-purchase', event);
      }
    }
  }

  pointsDotComDefined() {
    //return typeof (this.getPointsComConfig) !== 'undefined' && !(this.getPointsComConfig == {});
    const config = this.getPointsComConfig;
    return typeof config !== 'undefined' && config && Object.keys(config).length > 0;
  }

  pointsDotComBrandDefined() {
    //return typeof (this.getPointsComBrandConfig) !== 'undefined' && !(this.getPointsComBrandConfig == {});
    const brandConfig = this.getPointsComBrandConfig;
    return typeof brandConfig !== 'undefined' && brandConfig && Object.keys(brandConfig).length > 0;
  }
}

export default new PointsDotCom();

if ($_PAGE_.is('.rooms-rates-page')) {
  $(window).on('pageshow', function(event) {
    if (event.originalEvent) {
      // points Update
      UserHandler.ProfileUpdateOnPOints();
    }
  });
}
